import AffiliateSelector from './containers/AffiliateSelector.jsx';

export default AffiliateSelector;
